import { render } from "./Birth.vue?vue&type=template&id=01eb78c2"
import script from "./Birth.vue?vue&type=script&lang=js"
export * from "./Birth.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__